export enum EventMeta {
  MODEL = "event",
  PK = "id",
}

export enum EventTypeLevel {
  AUDIT = "audit",
  DEBUG = "debug",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  CRITICAL = "critical",
}
